/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class GroupsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      homerooms: this.store.query('group', { groupType: GroupType.HOMEROOM }),
      staff: this.store.query('person', { type: PersonType.STAFF }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
